<td *ngIf="checkable" class="patient-check">
  <input class="form-check-input" type="checkbox" [ngModel]="checked" (ngModelChange)="onCheckedChange($event)">
</td>

<td class="patient-name-wrapper" (click)="onClick.emit()">
  <msd-avatar [text]="initials" [src]="avatarUrl"></msd-avatar>
  <h5 class="title-text">{{ title }}</h5>
</td>

<td *ngIf="displayGroups" class="group-wrapper">
  <div>
    <div *ngFor="let group of groups" class="group-badge">{{ group }}</div>
  </div>
</td>

<td (click)="onClick.emit()"
    *ngIf="withActionButton"
    [tooltip]="dateTemplate"
    container="body"
    class="date-wrapper">
  <h5 class="date-text">{{ getDate() }}</h5>
</td>

<ng-template #dateTemplate>
  <div class="d-inline-flex">Date de création : {{
      createAt
        ? createAt.format('DD.MM.yyyy')
        : '--'
    }}
  </div>
  <div class="d-inline-flex">Dernière modification : {{
      updateAt
        ? updateAt.format('DD.MM.yyyy')
        : '--'
    }}</div>
  <div class="d-inline-flex">Dernière activité : {{
      lastSeen
        ? lastSeen.format('DD.MM.yyyy')
        : '--'
    }}</div>
</ng-template>

<td class="app-installed-wrapper" (click)="onClick.emit()">
  <div *ngIf="appInstalled" class="app-installed app-status-badge">
    <i class="status-icon" i-bs name="check" width="28" height="28"></i>
    <span class="installation-label">Installée</span>
  </div>
  <div *ngIf="!appInstalled" class="app-not-installed app-status-badge">
    <i class="status-icon" i-bs name="x" width="28" height="28"></i>
    <span class="installation-label">Non installée</span>
  </div>
  <!-- <i [tooltip]="'Ce patient utilise l\'application mobile'" *ngIf="appInstalled" class="status-icon" i-bs name="check"
    width="28" height="28"></i> -->
</td>

<td *ngIf="withActionButton" class="actions">
  <!-- <i class="iconly-Message email-icon"></i> -->

  <div class="dropdown" dropdown container="body">
    <button #bAct
            (click)="$event.stopPropagation()"
            [class.disabled]="isActionLoading"
            class="btn btn-outline-primary btn-outline icon-only circle more-action-button"
            dropdownToggle type="button">
      <ng-container *ngIf="isActionLoading else moreActionButton">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="visually-hidden">Chargement...</span>
      </ng-container>
      <ng-template #moreActionButton>
        <i i-bs name="three-dots" width="15" height="15"></i>
      </ng-template>
    </button>
    <div class="dropdown-backdrop fade"></div>
    <ul *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        [class.dropstart]="!offsetDropdown(bAct, 300)"
        [class.dropend]="offsetDropdown(bAct, 300)"
        role="menu">
      <li *ngIf="appInstalled" role="menuitem">
        <span class="dropdown-item send-encouragement"
              (click)="onEncouragement.emit()">Encourager</span></li>
      <li role="menuitem">
        <span class="dropdown-item" id="action-send-document" (click)="onSendDocument.emit()">Envoyer un document</span>
      </li>
      <li role="menuitem">
        <span class="dropdown-item send-message"
              (click)="onSendMessage.emit()">Envoyer un message</span>
      </li>
      <li role="menuitem">
        <span class="dropdown-item send-quiz"
              (click)="onSendSurvey.emit()">Envoyer un questionnaire</span>
      </li>
      <li class="divider dropdown-divider"></li>
      <li role="menuitem">
        <span class="dropdown-item send-quiz"
              (click)="onToDo.emit()">Ajouter une tâche</span>
      </li>
      <li class="divider dropdown-divider"></li>
      <li role="menuitem" class="desktop">
        <span class="dropdown-item add-to-group" (click)="onAddToGroup.emit()">Ajouter à un groupe</span>
      </li>
      <li role="menuitem" class="desktop">
        <span class="dropdown-item remove-to-group"
              [class.disabled]="!groups || groups.length === 0"
              (click)="removeToGroup()">Retirer d'un groupe</span>
      </li>
      <ng-container *ngIf="archivedAt; then activate; else archive">
      </ng-container>
      <ng-template #activate>
        <li role="menuitem"><span class="dropdown-item activated" (click)="onActivate.emit()">Activer</span></li>
      </ng-template>
      <ng-template #archive>
        <li role="menuitem"><span class="dropdown-item archived" (click)="onArchive.emit()">Archiver</span></li>
      </ng-template>
      <li class="divider dropdown-divider"></li>
      <li role="menuitem"><span id="cancel-link" class="dropdown-item action">Annuler</span>
      </li>
    </ul>
  </div>
</td>
